import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["aria-selected", "children", "onClick"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TableRowMixin } from '../../mixins/components/TableRowMixin';
export var StyledTableRow = /*#__PURE__*/styled.tr.withConfig({
  displayName: "StyledTableRow",
  componentId: "c11n-8-64-0__sc-1gk7etl-0"
})(["", ""], TableRowMixin);
/**
 * `Table.Row` is used by the [`Table`](#/Table%20components?id=table) component.
 * **This component should not be used on its own.**
 *
 * See [`Table`](#/Table%20components?id=table) for more examples.
 *
 * @since 8.0.0
 */

var TableRow = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var ariaSelected = _ref['aria-selected'],
      children = _ref.children,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledTableRow, _extends({
    "aria-selected": ariaSelected,
    onClick: onClick,
    ref: ref
  }, rest), React.Children.map(children, function (child, index) {
    return child && /*#__PURE__*/React.cloneElement(child, {
      index: index
    });
  }));
});
TableRow.displayName = 'Table.Row';
TableRow.propTypes = {
  /**
   * If true, displays the row in its "selected" state.
   *
   * @since 8.19.0
   */
  'aria-selected': PropTypes.bool,

  /**
   * The table cells. An index is added to each child cell for use by `TableSortableHeaderCell`.
   */
  'children': PropTypes.node.isRequired,

  /**
   * If true, the row's background color will change on hover. Primarily used
   * in conjuction with `onClick` and `aria-selected` to indicate a row is selectable.
   * It can also be used to help show the user where they are within a larger table.
   *
   * @since 8.19.0
   */
  'interactive': PropTypes.bool,

  /**
   * Callback function that's called whenever you click on the row.
   * Be sure to add `stopPropagation` to any clickable child elements
   * (ex: buttons or links).
   */
  'onClick': PropTypes.func
};
/** @component */

export default TableRow;